export const LocalStorageKey = {
  Announcement: 'verifier-announcement',
  RequestOpenForm: 'request-open-form',
  SelectedModule: 'verifiable.selectedModule'
};

export const DividerKey = '_DIVIDER_';

export const TableListSize = {
  Default: 20,
  MyNetworkList: 50,
  GroupList: 50,
  SanctionReportList: 50,
  ProviderMonitoringList: 100
};

export const ModalFakeInputElementId = 'modal-fake-input';

export const CustomServiceErrorMessage: ObjectType<string> = {
  'Address is not valid.': 'Please enter a valid address.',
  alertId: 'Alert not found. Reason:'
};

export const MonitoringErrors = [
  'Monitoring already enabled',
  'It looks like monitoring was already turned on'
];

export const EmptyLabelDefault = '--';

export const NoLabelKey = '_nolabel_';

export const RequestOpenFormTypes = {
  BasicInfo: 'BasicInfo',
  NewLicense: 'NewLicense',
  NewNpi: 'NewNpi',
  NewEducation: 'NewEducation',
  NewBoard: 'NewBoard',
  EditBoard: 'EditBoard'
};
